
(function fPageLoad() {
  if (document.querySelectorAll('.js-toggle-menu').length) { initNavigation(); }
  if (document.querySelectorAll('.js-form-validate').length) { formValidation(); }
  if (document.querySelectorAll('.js-sticky-header').length) { fStickyHeader(); }
  if (document.querySelectorAll('.js-to-top').length) { fBackToTop(); }
  if (document.querySelectorAll('.js-slider').length) { fSliders(); }
  if (document.querySelectorAll('.js-dropdown').length) { fDropdown(); }
  if (document.querySelectorAll('.js-tooltip').length) { fTooltip(); }
  if (document.querySelectorAll('.js-video').length) { fPlayVideo(); }
  if (document.querySelectorAll('.js-tabs').length) { fInitTabs(); }
  if (document.querySelectorAll('.js-custom-select').length) { fInitCustomSelects(); }
  if (document.querySelectorAll('.sticky').length) { fSticky(); }
  if (document.querySelectorAll('.js-draggable').length) { draggable.initialize(); }
  if (document.querySelectorAll('.js-accordion').length) { fAccordion(); }
    
  if (!browserCanUseCssVariables()) {
    cssVars();
  }
}());

window.onload = () => {
  objectFitImages(null, { watchMQ: true });
    if (document.querySelectorAll('.js-modal').length) { initModals(); }

    if (document.querySelectorAll('.js-hero').length) { fHomeHeroAnimation(); }

};

window.addEventListener('resize', () => {
  website.iScreenWidth = document.body.getBoundingClientRect().width;
});

/* Register ServiceWorker */
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/sw.js')
    .then(() => {
      // SW registered
    });
}
